import {Controller} from "stimulus"
import $ from 'jquery';

let ban_remain_time = (obj) => {
    let timeOut = 1000;

    let interval = setInterval(function () {
        // Fecha futura en milisegundos
        let date_future = new Date(obj.dataset.timeout * 1000);
        // Fecha actual
        let date_now = new Date();

        // Diferencia en milisegundos
        let diff_ms = date_future - date_now;

        // Si la diferencia es menor o igual a cero, detener el intervalo
        if (diff_ms <= 0) {
            $(obj).text(`0 ${I18n.t('global.time.centuries')} - 0 ${I18n.t('global.time.years')} - 0 ${I18n.t('global.time.months')} - 0 ${I18n.t('global.time.day')} - 0 ${I18n.t('global.time.hours')} - 0 ${I18n.t('global.time.minutes')} - 0 ${I18n.t('global.time.seconds')}`);
            clearInterval(interval);
            return;
        }


        // Convertir la diferencia en segundos
        let diff_seconds = Math.floor(diff_ms / 1000);

        // Calcular años
        let centuries = Math.floor(diff_seconds / (100 * 365 * 24 * 60 * 60));
        diff_seconds -= centuries * 100 * 365 * 24 * 60 * 60;

        // Calcular años
        let years = Math.floor(diff_seconds / (365 * 24 * 60 * 60));
        diff_seconds -= years * 365 * 24 * 60 * 60;

        // Calcular meses (aproximadamente 30.44 días por mes)
        let months = Math.floor(diff_seconds / (30.44 * 24 * 60 * 60));
        diff_seconds -= months * 30.44 * 24 * 60 * 60;

        // Calcular días
        let days = Math.floor(diff_seconds / (24 * 60 * 60));
        diff_seconds -= days * 24 * 60 * 60;

        // Calcular horas
        let hours = Math.floor(diff_seconds / (60 * 60));
        diff_seconds -= hours * 60 * 60;

        // Calcular minutos
        let minutes = Math.floor(diff_seconds / 60);
        diff_seconds -= minutes * 60;

        // Segundos restantes
        let seconds = Math.round(diff_seconds);

        // Actualizar el texto del elemento con la cuenta atrás
        $(obj).html(
            `${centuries} ${I18n.t('global.time.centuries')} - ` +
            `${years} ${I18n.t('global.time.years')} - ` +
            `${months} ${I18n.t('global.time.months')} - ` +
            `${days} ${I18n.t('global.time.day')}<br>` +
            `${hours} ${I18n.t('global.time.hours')} - ` +
            `${minutes} ${I18n.t('global.time.minutes')} - ` +
            `${(seconds < 10 ? '0' + seconds : String(seconds))} ${I18n.t('global.time.seconds')}`
        );

    }, timeOut);
};



export default class extends Controller {

    connect() {
       ban_remain_time(this.element);
    }
}